import { inject, Injectable } from '@angular/core';
import { filter, Observable } from 'rxjs';
import { FacadeKey } from '@lib.core/view/view-key';
import { Store } from '@lib.core/store/store.service';

@Injectable({ providedIn: 'root' })
export class FacadeKeyStorageService {
  private readonly store = inject(Store);
  private readonly key = 'facade-key';

  setFacadeKey(facadeKey: FacadeKey): void {
    this.store.setValue(this.key, facadeKey);
  }

  getFacadeKey(): Observable<FacadeKey> {
    return this.store.getValue<FacadeKey>(this.key).pipe(filter((v: FacadeKey | null | undefined) => v != null));
  }
}
